// extracted by mini-css-extract-plugin
export default {"modalOverlay":"GA-z","modalContent":"HA-z","header":"IA-z","close":"JA-z"};